import React, { useState } from 'react';

const AdminView = ({ subscriptions, mandanti, rebelnetCampaigns, onToggleAll, onDelete }) => {
  const [userFilter, setUserFilter] = useState('');

  const filteredSubscriptions = subscriptions.filter(s => 
    !userFilter || s.userId.toLowerCase().includes(userFilter.toLowerCase())
  );

  return (
    <div className="admin">
      <h2>Tutti i Dispositivi Registrati</h2>
      <input 
        type="text" 
        placeholder="Filtra per email utente..." 
        value={userFilter}
        onChange={(e) => setUserFilter(e.target.value)}
        className="admin-filter"
        aria-label="Filtra utenti"
      />
      <p style={{ fontSize: '0.85rem', color: 'var(--color-gray-500)', marginBottom: 'var(--space-md)' }}>
        Totale: {filteredSubscriptions.length} dispositivi
      </p>
      <div className="subscriptions-list">
        {filteredSubscriptions.map(sub => (
          <div key={`${sub.userId}-${sub.deviceId}`} className="subscription-card">
            <div className="subscription-info">
              <p><strong>User:</strong> {sub.userId}</p>
              {sub.deviceInfo && <p><strong>Dispositivo:</strong> {sub.deviceInfo}</p>}
              {sub.createdAt && <p><strong>Registrato:</strong> {new Date(sub.createdAt).toLocaleString('it-IT')}</p>}
              <p><strong>Notifiche attive:</strong> {sub.enabledMandanti?.length > 0 ? sub.enabledMandanti.join(', ') : 'Nessuna'}</p>
            </div>
            <div className="subscription-actions">
              <button 
                className="toggle-all-btn"
                onClick={() => onToggleAll(sub.userId, sub.deviceId, sub.enabledMandanti?.length !== mandanti.length)}
                style={{ backgroundColor: sub.enabledMandanti?.length === mandanti.length ? 'var(--color-danger)' : 'var(--color-success)' }}
              >
                {sub.enabledMandanti?.length === mandanti.length ? 'Disattiva' : 'Attiva Tutte'}
              </button>
              <button className="btn-danger btn-small" onClick={() => onDelete(sub.userId, sub.deviceId)}>
                Elimina
              </button>
            </div>
          </div>
        ))}
        {subscriptions.length === 0 && (
          <div className="empty-state">
            <div className="empty-state-icon">👥</div>
            <div className="empty-state-text">Nessun dispositivo registrato</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminView;
